import { APP_CONFIG } from '@core/configs';

export const API_BASE_URL = APP_CONFIG.apiBaseUrl + "/";
export const TOKEN_URL = APP_CONFIG.tokenUrl;
export const AUTH_URL = APP_CONFIG.authUrl;
export const SAUCER_LOG_API = APP_CONFIG.saucerLogUrl;
export const SAUCER_LOG_TOKEN = APP_CONFIG.saucerLogToken;

export const API_ENDPOINT = {
  token: {
    login: API_BASE_URL + 'auth/login-by-staff',
    logout: TOKEN_URL + '/token/logout',
    refreshToken: TOKEN_URL + '/token/refresh',
    verifyAndGetCkapi : TOKEN_URL + '/ck-pass/token/verify-and-get-ckapi',
    cust: API_BASE_URL + 'auth/login-by-custid',
    deviceId: API_BASE_URL + 'auth/login-by-deviceid',
  },
  auth: {
    checkExistsCorpPrefix: AUTH_URL + '/auth/check-exists-corpprefix',

  },
  health: {
    health: API_BASE_URL + 'health',
    getByOffice: API_BASE_URL + 'get-by-office',
    getByUnit: API_BASE_URL + 'get-by-unit',
    getByCondition: API_BASE_URL + '/get-by-unit',
  },
  office: {
    getOfficeType: API_BASE_URL + 'office/get-office-type',
    getBlockAndUnitByOffice: API_BASE_URL + 'office/get-block-and-unit-by-office',
    getGroupByOffice: API_BASE_URL + 'office/get-group-by-office',
    getLastSyncMasterDate: API_BASE_URL + 'office/get-last-sync-master-date',
    getLatestSyncDate: API_BASE_URL + 'office/get-latest-sync-date'
  },
  deviceRegistrations: {
    updateHeartbeat: API_BASE_URL + 'device/update-heartbeat',
    updateCKDataChangedAt: API_BASE_URL + 'device/update-CKDataChangedAt',
  },
  deviceLogs: {
    save: API_BASE_URL + 'device-logs',
  },
  deviceLicenses: {
    getLogEnabledByDeviceId: API_BASE_URL + 'device-licenses/get-log-enabled-by-device-id',
    syncLogEnabledByDeviceId: API_BASE_URL + 'device-licenses/sync-log-enabled-by-device-id',
    applyLogEnabledByDeviceId: API_BASE_URL + 'device-licenses/apply-log-enabled-by-device-id',
    updateNameByDeviceId: API_BASE_URL + 'device-licenses/update-name-by-device-id',
    updateMetadataByDeviceId: API_BASE_URL + 'device-licenses/update-metadata-by-device-id',
    getNameByDeviceId: API_BASE_URL + 'device-licenses/get-name-by-device-id',
    updateLoginCustomerInfoByDeviceId: API_BASE_URL + 'device-licenses/update-login-customer-info-by-device-id',
    saveLoginCustomerInfoBeforeOfficeByDeviceId: API_BASE_URL + 'device-licenses/save-login-customer-info-before-office-by-device-id',
    updateSettingConfigByDeviceId: API_BASE_URL + 'device-licenses/update-setting-config-by-device-id',
    clearLoginCustomerInfoByDeviceId: API_BASE_URL + 'device-licenses/clear-login-customer-info-by-device-id',
  },
  clientLog: {
    write: API_BASE_URL + 'client-log/write',
  },
  dai: {
    getDaiInfo: API_BASE_URL + 'dai/infos',
    getDaiByPeriod: API_BASE_URL + 'dai/get-period',
    getBathScheduled: API_BASE_URL + 'dai/bath-scheduled',
  },
  checkSheet: {
    getByOffice: API_BASE_URL + 'check-sheet/get-by-office',
    getByUnit: API_BASE_URL + 'check-sheet/get-by-unit',
    getByCondition: API_BASE_URL + 'check-sheet/get-by-condition',
    manualSyncCkdata: API_BASE_URL + 'check-sheet/manual-sync-ckdata',
    getValidSchedulePeriod: API_BASE_URL + 'check-sheet/get-valid-schedule-period',
  },
  excreation: {
    getByOffice: API_BASE_URL + 'excreation/get-by-office',
  },
  realtimedb: {
    getSessionToken: API_BASE_URL + 'realtimedb/get-session-token',
    getFirebaseToken: API_BASE_URL + 'realtimedb/get-firebase-token'
  },
  firebase: {
    refreshDeviceDb: API_BASE_URL + 'firebase/refresh-device-db',
  },
  screenConfig: {
    save: API_BASE_URL + 'screen-config/save',
    getByStaff: API_BASE_URL + 'screen-config/get-by-staff'
  },
  screenTitleConfig: {
    save: API_BASE_URL + 'screen-title-config/save',
    getByStaff: API_BASE_URL + 'screen-title-config/get-by-screen',
    syncTitleMaster: API_BASE_URL + 'screen-title-config/sync-title-master',
    getTitleMaster: API_BASE_URL + 'screen-title-config/get-title-master',
    checkMasterExist: API_BASE_URL + 'screen-title-config/check-master-exist',
    setTitleSettingToDefault: API_BASE_URL + 'screen-title-config/gen-title-setting-default',
    getTitleAfterLogin: API_BASE_URL + 'batch-job/get-title-after-login',
    updateCorpCd: API_BASE_URL + 'office/update-cordCd',
    getKbntagsSettings: API_BASE_URL + 'screen-title-config/get-kbntags-settings',
    getTitleByTags: API_BASE_URL + 'screen-title-config/get-title-by-tags',
    getAnswerByTags: API_BASE_URL + 'screen-title-config/get-answer-by-tags',
    getKbnTags: API_BASE_URL + 'screen-title-config/kbntags',
    getTitletagSettingsByKbnTags: API_BASE_URL + 'screen-title-config/get-titletag-settings-by-kbntags',
    setTagsDefaultByColName: API_BASE_URL + 'screen-title-config/gen-tags-default-by-colname',
    getYoteisByTags:API_BASE_URL + 'screen-title-config/get-yoteis-by-tags',
    genYoteiToDefaultByColName: API_BASE_URL + 'screen-title-config/gen-yotei-default-by-colname',
  },
  userDashboard:{
    getUser:API_BASE_URL + 'user-dashboard/get-user',
    getImage: API_BASE_URL + 'api/ImageProxy',
    getMetaData: API_BASE_URL + 'api/ImageProxy/metadata',
    getUserVideo: API_BASE_URL + 'api/ImageProxy/userVideo',
  },
  bathRoomSetting:{
    getBathRoomInfo: API_BASE_URL + 'bath-room-setting/get-bath-room',
    getBathDai: API_BASE_URL + 'bath-room-setting/bath-dai/get',
    getBathDaily: API_BASE_URL + 'bath-room-setting/bath-daily/get',
    insertOrUpdateBathRoom: API_BASE_URL + 'bath-room-setting/insert-or-update-bath-room',
    deleteBath: API_BASE_URL + 'bath-room-setting/delete-bath',
    updateBathDai: API_BASE_URL + 'bath-room-setting/update-bath-dai',
    insertBathDaily: API_BASE_URL + 'bath-room-setting/insert-bath-daily',
    updateBathDaily: API_BASE_URL + 'bath-room-setting/update-bath-daily',
    deleteAllOrtherBathDailyByDate: API_BASE_URL + 'bath-room-setting/bath-daily-delete-date',

    // New endpoints
    getBathroomSummary: API_BASE_URL + 'bath-room-setting/bath-room-summaries',
    getBathroomByKey: API_BASE_URL + 'bath-room-setting/bathroom-by-key',
    createBathroom: API_BASE_URL + 'bath-room-setting/create-bathroom',
    updateBathroom: API_BASE_URL + 'bath-room-setting/update-bathroom',
    deleteBathroom: API_BASE_URL + 'bath-room-setting/bathroom-delete',
    updateBathdai: API_BASE_URL + 'bath-room-setting/update-bathdai',
    moveBathdai: API_BASE_URL + 'bath-room-setting/move-bathdai',
    previewBathdaiChange: API_BASE_URL + 'bath-room-setting/preview-bathdai-change',
    bathLogs: API_BASE_URL + 'bath-room-setting/bath-logs',
    updateLogs: API_BASE_URL + 'bath-room-setting/upsert-logs',
    updateDaily: API_BASE_URL + 'bath-room-setting/update-daily',
  },
  bath: {
    getBathLastestAction: API_BASE_URL + 'bath/get-bath-actions',
    getAttentionListWithRange: API_BASE_URL + 'bath/get-attention-list',
  },
  avatar: {
    batchOptimize: API_BASE_URL + 'api/ImageProxy/user-avatar-sync-batch',
  },
  holiday: {
    getByPeriod: API_BASE_URL + 'holidate/get-by-period',
  },
  saucerLog: {
    logBulk: SAUCER_LOG_API + 'log/caremoni/bulk',
  }
};

export const DEVICE_LOGIN_HEADERS = {
  deviceId: 'X-CareMoni-Device-Id',
  token: 'X-CareMoni-Device-Token',
} as const;

export const getApiPath = (fullUrl: string) => {
  return fullUrl.replace(API_BASE_URL, '').replace(TOKEN_URL + '/', '').replace(AUTH_URL + '/', '');
};
